import React from "react";
import { DetailItem, LimitsApplyAccordion } from ".";
import { BenefitItemProps } from "../@types";
import {
  getBenefitCost,
  getBenefitExclusionsAndLimitations,
  useTranslate,
} from "../helpers";
import { shouldSuppressPlanBenefits } from "../helpers/planHelpers";

const BenefitItem: React.FunctionComponent<BenefitItemProps> = ({
  label,
  plan,
  ...bscProps
}) => {
  const t = useTranslate();
  return (
    <DetailItem
      label={label}
      detail={getBenefitCost(t, { ...bscProps, plan })}
      suppressed={shouldSuppressPlanBenefits(plan)}
      limitsApply={
        <LimitsApplyAccordion
          descriptors={getBenefitExclusionsAndLimitations({
            ...bscProps,
            plan,
          })}
        />
      }
    />
  );
};

export default BenefitItem;
